import { $host } from '../index';
import Cookies from 'js-cookie';

//===========
// begin [ Epidemics_Calculation ]

export const getEpidemics_Infection_List = async () => {
    const {data} = await $host.get('api/epidemics/epidemics_data/infections', {params: {token: Cookies.get('token')}});
    return data;
}

export const getEpidemics_Town_List = async () => {
    const {data} = await $host.get('api/epidemics/epidemics_data/towns', {params: {token: Cookies.get('token')}});
    return data;
}

export const getEpidemics_Town_Convex_Hulls = async (bounds) => {
    const {data} = await $host.get('api/epidemics/epidemics_data/towns/convex_hulls', {params: {
        token: Cookies.get('token'),
        W: bounds['_southWest']['lng'], S: bounds['_southWest']['lat'],
        E: bounds['_northEast']['lng'], N: bounds['_northEast']['lat']
    }});
    return data;
}

export const getEpidemics_Town_Boundaries = async (id) => {
    const {data} = await $host.get('api/epidemics/epidemics_data/towns/boundaries/' + id, {params: {token: Cookies.get('token')}});
    return data;
}

export const getEpidemics_Calculation_List = async () => {
    const {data} = await $host.get('api/epidemics/epidemics_data/calculations', {params: {token: Cookies.get('token')}});
    return data;
}

export const getEpidemics_Calculation_Metadata = async (id = false) => {
    if (id) { const {data} = await $host.get('api/epidemics/epidemics_data/calculations/metadata/' + id, {params: {token: Cookies.get('token')}}); return data; }
    else { const {data} = await $host.get('api/epidemics/epidemics_data/calculations/metadata', {params: {token: Cookies.get('token')}}); return data; }
}

export const getEpidemics_Calculation_Data = async (id) => {
    const {data} = await $host.get('api/epidemics/epidemics_data/calculations/data/' + id, {params: {token: Cookies.get('token')}});
    return data;
}

export const performEpidemics_Calculation = async (name, model, infection, town, outbreak, beta, sigma, gamma, radius) => {
    try {
        const {data} = await $host.get('api/epidemics/epidemics_calculation/dSEIR', {params: {
            token: Cookies.get('token'),
            name: name,
            model: model,
            infection: infection,
            town: parseInt(town),
            outbreak_lat: parseFloat(outbreak[0]),
            outbreak_lon: parseFloat(outbreak[1]),
            beta: parseFloat(beta),
            sigma: parseFloat(sigma),
            gamma: parseFloat(gamma),
            radius: parseFloat(radius)
        }});

        if (data.result === true)
            return { success: true, data: data };
        else
            throw new Error(data.error);
    } catch (error) {
        return { success: false, error: error.response?.data?.error ?? error.message };
    }
}

export const renameEpidemics_Calculation = async (id, new_name) => {
    try {
        const {data} = await $host.patch('api/epidemics/epidemics_data/calculations/' + id, {}, {params: {
            token: Cookies.get('token'),
            new_name: new_name
        }});
        return { success: true, data: data };
    } catch (error) {
        return { success: false, error: error.response?.data?.error || error.message };
    }
}

export const deleteEpidemics_Calculation = async (id) => {
    try {
        const {data} = await $host.delete('api/epidemics/epidemics_data/calculations/' + id, {params: {token: Cookies.get('token')}});
        return { success: true, data: data };
    } catch (error) {
        return { success: false, error: error.response?.data?.error || error.message };
    }
}

// end [ Epidemics_Calculation ]
//===========

//-----------
